export const WEB_DATETIME_FORMAT = 'DD-MMM-yyyy HH:mm'
export const WEB_DATETIME_FORMAT_12HRS = 'DD-MMM-yyyy hh:mm A'
export const SERVER_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.sssZ'
export const NO_WEB_DATETIME_FORMAT = 'DD-MMM-yyyy'
